const equipmentChangeStatusInput = {
  activeTitle: 'EQUIPAMENTO',
  activeTitleTrue: 'INATIVAR',
  activeTitleFalse: 'REATIVAR',
  maintenanceTitle: 'MANUTENÇÃO',
  maintenanceTitleTrue: 'RETORNAR DA',
  maintenanceTitleFalse: 'ENVIAR PARA A',
};

export default equipmentChangeStatusInput;
